<template>
    <div v-if="ready">
        <onboarding-layout v-if="showOnboarding && (!showNotification || isForced)">
            <template #header>
                <template v-if="!isAllCompleted">
                    <span @click="pauseOnboarding = true" v-if="!pauseOnboarding && !isForced"><h1 style="cursor:pointer; right:0"> X </h1></span>
                    
                </template>

                <h3 style="text-align:center;" v-else>
                    {{ $t('congratulations') }}
                </h3>
            </template>

            <template #default>
                <div v-if="pauseOnboarding && !isForced" style="text-align:center">
                    <h5>{{ $t('pauseOnboardingWarning') }} </h5>
                    <b-row class="mt-5">
                        <b-col><b-button variant="warning" @click="pause" block>{{ $t('yes') }}</b-button></b-col>
                        <b-col><b-button variant="success" @click="pauseOnboarding = false" block>{{ $t('no') }}</b-button></b-col>
                    </b-row>
                </div>
                
                <div v-else>
                    <b-row v-if="currentOnboarding">
                        <b-col cols="12" v-if="currentOnboarding.type == 'platform' && currentOnboarding.id == 'locale'">
                            <b-form-group
                                :label="$t(`choosePreferedLanguage`)"
                            >
                                <b-select :options="localeOptions" v-model="initialLocale"/>
                                <b-button @click="saveLocale" variant="success" class="mt-2" block :disabled="stepInProcess"> {{ $t('save') }} </b-button>
                            </b-form-group>
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'integration'">
                            <RenderOnboarding @onboardingSuccess="onboardingSuccess" tag="div" :only="currentOnboarding.id" :key="currentOnboarding.id" @updateOnboarding="updateIntegrationOnboarding"/>
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'app'">
                            <AppOnboarding :id="currentOnboarding.id" @onboardingSuccess="onboardingSuccess" />
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'public-app'">
                            <PublicAppOnboarding :id="currentOnboarding.id" @onboardingSuccess="onboardingSuccess" />
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'billing'">
                            <BillingInfo @saved="onBillingOnboardingSaved" />
                        </b-col>

                        <b-col cols="12" v-if="currentOnboarding.type == 'payment'">
                            <PaymentStep :subscription="pendingSub" @paid="onPaymentDone" @dismissed="onPaymentDismissed" />
                        </b-col>
                    </b-row>

                    <div v-if="isAllCompleted" class="onboarding-complete-state">
                        <div class="onboarding-complete-icon">✓</div>
                        <h4 class="onboarding-complete-title">{{ $t('congratulations') }}</h4>
                        <p class="onboarding-complete-text">{{ $t('onboardingCongrats') }}</p>
                        <b-button variant="success" size="lg" class="onboarding-complete-btn" @click="close">{{ $t('continue') }}</b-button>
                    </div>
                </div>
            </template>
        </onboarding-layout>

        <OnboardingNotification v-if="!isForced" :shouldContinue="showNotification"/>

        <onboarding-layout v-if="isForced && !showOnboarding && !showNotification">
            <template #header><span /></template>
            <template #default>
                <div class="onboarding-complete-state">
                    <div class="onboarding-complete-icon">✓</div>
                    <h4 class="onboarding-complete-title">{{ $t('congratulations') }}</h4>
                    <p class="onboarding-complete-text">{{ $t('allOnboardingsComplete') }}</p>
                    <b-button variant="success" size="lg" class="onboarding-complete-btn" @click="$router.push('/')">{{ $t('goToHome') }}</b-button>
                </div>
            </template>
        </onboarding-layout>
    </div>
</template>

<script>
import OnboardingLayout from './OnboardingLayout'
import OnboardingNotification from './OnboardingNotification'
import RenderOnboarding from '@/components/integrations/RenderOnboarding'
import vSelect from 'vue-select'
import AppOnboarding from '@/views/apps/Onboarding'
import BillingInfo from '@/views/users/BillingInfo'
import PaymentStep from '@/views/dashboard/PaymentStep'
//import PublicAppOnboarding from '@/views/publicapps/Onboarding'

export default {
    components: {
        OnboardingLayout,
        RenderOnboarding,
        vSelect,
        OnboardingNotification,
        AppOnboarding,
        BillingInfo,
        PaymentStep,
        //PublicAppOnboarding
    },

    data: () => {
        return {
            ready: false,
            success: false,
            pauseOnboarding: false,
            locale: 'en_US',
            localeOptions: [
                {
                    value: 'en_US',
                    text: 'English (US)'
                },
                {
                    value: 'sr',
                    text: 'Serbian'
                },
            ],

            stepInProcess: false,

            initiatedOnboarding: [],

            pendingSub: null
        }
    },

    methods: {
        onboardingSuccess(type, id) {
            console.log("onboardingSuccess", type, id)
            this.initiatedOnboarding = this.initiatedOnboarding.map(i => {
                if (i.type == type && i.id == id) {
                    i.completed = true
                }

                return i
            })
        },

        async updateIntegrationOnboarding(integrationId, step, data) {
            try {
                console.log("updateIntegrationOnboarding", integrationId, step, data)
                await this.$store.dispatch('updateIntegrationOnboarding', {
                    integrationId,
                    step,
                    data
                })
            } catch(err) {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })
            }
        },

        async saveLocale() {
            try {
                this.stepInProcess = true;
                await this.$store.dispatch("updateUserConfig", { path: "locale", data: { locale: this.locale } })

                this.$store.commit('SET_LOCALE', this.locale)
                this.$i18n.locale = this.locale

                this.onboardingSuccess("platform", "locale")
            } catch(err) {
                console.error(err)
                
                this.$bvToast.toast(this.$t('unexpectedError'), {
                    variant: 'danger'
                })
            } finally {
                this.stepInProcess = false
            }
        },

        async pause() {
            this.$store.dispatch('pauseOnboarding')
            this.pauseOnboarding = false
        },

        onBillingOnboardingSaved() {
            this.onboardingSuccess('billing', 'billing')
        },

        onPaymentDone() {
            this.onboardingSuccess('payment', 'payment')
        },

        onPaymentDismissed() {
            this.pendingSub = null
            this.onboardingSuccess('payment', 'payment')
        },

        async close() {
            this.initiatedOnboarding = []
            if (this.isForced) {
                // If we're running inside the platform-forge onboarding overlay,
                // signal completion so the iframe can close and the app can start.
                if (window.parent !== window) {
                    window.parent.postMessage({ type: 'forge_onboarding_complete' }, '*')
                    return
                }
                this.$router.push('/')
            }
        },

        async loadOnboardings() {
            this.initiatedOnboarding = []
            this.pendingSub = null
            try {
                this.$store.dispatch("fetchUserConfigs").then(() => {
                    let lang = this.$store.getters.userConfig("locale")
                    if (lang.length < 1) {
                        this.initiatedOnboarding.push({
                            priority: 1,
                            type: 'platform',
                            id: 'locale',
                            completed: false
                        })
                    }
                })

                // Force-refresh all data sources so stale cached state (e.g. an
                // onboarding completed inside the forge app) is not presented again.
                this.$store.commit('SET_APPS', null)
                await Promise.all([
                    this.$store.dispatch("fetchApps"),
                    this.$store.dispatch("refreshForgeApps"),
                    this.$store.dispatch("fetchIntegrations", true),
                    //this.$store.dispatch("fetchPublicAppsOnboarding")
                ])

                if (!this.$isAdmin()) return

                const allSubs = await this.$store.dispatch('fetchSubscriptions', true)
                const pendingSub = allSubs ? allSubs.find(function(s) { return s.payment_status === 'pending' && !s.is_trial }) : null
                if (pendingSub) {
                    this.pendingSub = pendingSub

                    const existingBilling = this.$store.getters.getUser.settings.billing_address
                    const billingFilled = existingBilling && existingBilling.type

                    if (!billingFilled) {
                        this.initiatedOnboarding.push({
                            priority: 0,
                            type: 'billing',
                            id: 'billing',
                            completed: false
                        })
                    }

                    this.initiatedOnboarding.push({
                        priority: 1,
                        type: 'payment',
                        id: 'payment',
                        completed: false
                    })
                }

                const onboardingIntegrations = this.$store.getters.getOnboardingRequiredIntegrations || []
                onboardingIntegrations.forEach(o => {
                    console.log("onboarding integration", o)
                    if (!o.onboarding) return

                    this.initiatedOnboarding.push({
                        priority: 2,
                        type: 'integration',
                        id: o.id,
                        completed: o.onboarding.status == "completed"
                    })
                })

                const onboardingPlatformApps = this.$store.getters.getOnboardingRequiredPlatformApps || []
                onboardingPlatformApps.forEach(o => {
                    if (o.onboarding.finished) return

                    this.initiatedOnboarding.push({
                        priority: 3,
                        type: 'app',
                        id: o.uuid,
                        completed: o.onboarding.finished
                    })
                })

                // const onboardingPublicApps = this.$store.getters.getOnboardingRequiredPublicApps || []
                // onboardingPublicApps.forEach(o => {
                //     if (o.onboarding.finished) return

                //     this.initiatedOnboarding.push({
                //         priority: 4,
                //         type: 'public-app',
                //         id: o.uuid,
                //         completed: o.onboarding.finished
                //     })
                // })

                console.log("initiatedOnboarding", this.initiatedOnboarding)

            } catch(err) {
                console.error(err)
            } finally {
                this.initiatedOnboarding.sort((a, b) => a - b)
            }
        }
    },

    watch: {
        showNotification(newVal, oldVal) {
            // User unpaused onboarding — re-fetch fresh data so any onboardings
            // completed while paused (e.g. inside the forge app) are excluded.
            if (oldVal === true && newVal === false) {
                this.loadOnboardings()
            }
        },

        '$store.getters.getOnboardingRefreshKey'() {
            this.loadOnboardings()
        }
    },

    computed: {
        isForced() {
            return this.$route && this.$route.name === 'Onboarding'
        },

        isAllCompleted() {
            return this.initiatedOnboarding.filter(i => !i.completed).length < 1
        },

        currentOnboarding() {
            // is there any platform onboarding?
            const platformOnboarding = this.initiatedOnboarding.find(i => i.type == "platform" && !i.completed)
            if (platformOnboarding) {
                return platformOnboarding
            }

            const n = this.initiatedOnboarding.find(i => !i.completed)

            return n
        },

        showNotification() {
            if (this.isForced) return false
            
            return this.$store.getters.getPausedOnboardings.length > 0
        },

        showOnboarding() {
            return this.initiatedOnboarding.length > 0
        },

        initialLocale: {
            get() {
                return 'en_US'
            },

            set(val) {
                this.locale = val
                this.$root.$i18n.locale = val
            }
        }
    },

    async mounted() {
        try {
            await this.loadOnboardings()
        } finally {
            this.ready = true
        }
    }
}
</script>

<style scoped>
.onboarding-complete-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 2.5rem 1.5rem;
    color: #fff;
}

.onboarding-complete-icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: linear-gradient(135deg, #28a745, #20c997);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    color: #fff;
    font-weight: 700;
    margin-bottom: 1.5rem;
    box-shadow: 0 8px 24px rgba(40, 167, 69, 0.35);
}

.onboarding-complete-title {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    color: #fff;
}

.onboarding-complete-text {
    font-size: 0.95rem;
    color: rgba(255, 255, 255, 0.72);
    max-width: 420px;
    line-height: 1.6;
    margin-bottom: 2rem;
}

.onboarding-complete-btn {
    min-width: 160px;
    padding: 0.6rem 2rem;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(40, 167, 69, 0.3);
}
</style>